import React from 'react';
import EntityForm from './EntityForm';

function ManageTeamForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Team"
            heading="Add New Team"
            insertUrl="insert_manage_team"
            fields={[
                { name: 'name', label: 'Name', required: true },
                { name: 'email', label: 'Email' },
                { name: 'address', label: 'Address' },
                { name: 'contact', label: 'Contact No.' },
                { name: 'username', label: 'Username', required: true },
                { name: 'password', label: 'Password', required: true },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageTeamForm;
